import { c as _c } from "react/compiler-runtime";
import { SingleColumnLayout } from '../SingleColumnLayout/SingleColumnLayout';
import styles from './Headlines.module.scss';
import type { HeadlineItem } from './Headlines.utils';
import { HeadlinesArticle } from './HeadlinesArticle';
type Props = {
  items: HeadlineItem[];
};
export function Headlines(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className={styles.titlePrimary}>Schlagzeilen</h1>;
    t2 = <h2 className={styles.titleSecondary}>Alle News von BR24 im Überblick</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items) {
    t3 = <SingleColumnLayout contentClassName={styles.content}>{t1}{t2}<section className={styles.sectionRoot}>{items.length === 0 ? <p className={`body1 ${styles.noPublishedArticles}`}>Es wurden heute noch keine Artikel veröffentlicht.</p> : <section className={styles.section}><ul className={`${styles.list} body1`}>{items.map(_temp)}</ul></section>}</section></SingleColumnLayout>;
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(item) {
  return <HeadlinesArticle key={item.id} date={item.date} icon={item.icon} path={item.path} title={item.title} />;
}